import { HousingTypeEnum, TarificationIdEnum, HeatingTypeEnum, UtilityTypeEnum, ContractTypeEnum, InvoicingMethodEnum, FixedTermDurationUnit, ContractReasonEnum } from "./CommonEnums";
import { IAddressViewModel, IContactPersonViewModel, IPriceListViewModel, IContractViewModel } from "./I4UViewModels";
import * as moment from "moment-recent";
import VueI18n from "vue-i18n";

export class InvoicingMethodFormat {
    public static toString(invoicingMethod: InvoicingMethodEnum): string {
        switch (invoicingMethod) {
            case InvoicingMethodEnum.Paper: return "Paperilasku";
            case InvoicingMethodEnum.ConsumerEInvoice: return "E-lasku";
            case InvoicingMethodEnum.CompanyEInvoice: return "Verkkolasku";
            case InvoicingMethodEnum.Email: return "Sähköpostilasku";
            case InvoicingMethodEnum.DirectPayment: return "Suoraveloitus";
            case InvoicingMethodEnum.Online:
            case InvoicingMethodEnum.Print:
                return "TODO: Lisää teksti"; // TODO: Add proper texts.
            default: return null;
        }
    }
}

export class ContractTypeFormat {
    public static toString(contractType: ContractTypeEnum): string {
        switch (contractType) {
            case ContractTypeEnum.Unknown: return "Tuntematon";
            case ContractTypeEnum.SalesContract: return "Myyntisopimus";
            case ContractTypeEnum.NetworkContract: return "Verkkosopimus";
            case ContractTypeEnum.PurchaseContract: return "Ostosopimus"
            case ContractTypeEnum.ServiceContract:
            case ContractTypeEnum.ServiceConnectionContract:
            case ContractTypeEnum.ReconciliationContract:
            case ContractTypeEnum.ConsolidatedContract:
            case ContractTypeEnum.SupplyContract: return "Toimitussopimus";
            case ContractTypeEnum.WholeSaleContract:
            case ContractTypeEnum.BackingContract:
            case ContractTypeEnum.PriceLimitContract:
            case ContractTypeEnum.PriceGuaranteedContract:
            case ContractTypeEnum.NetworkProductionContract:
                return "TODO: Lisää teksti (" + contractType.toString()+")"; // TODO: Add proper texts.
            default: return null;
        }
    }
}

export class UtilityTypeFormat {
    public static toString(utilityType: UtilityTypeEnum): string {
        switch (utilityType) {
            case UtilityTypeEnum.NotDefined: return "Ei valittu";
            case UtilityTypeEnum.Electricity: return "Sähkö";
            case UtilityTypeEnum.DistrictHeat: return "Kaukolämpö";
            case UtilityTypeEnum.DistrictCooling: return "Kaukojäähdytys";
            case UtilityTypeEnum.Gas: return "Kaasu";
            case UtilityTypeEnum.Water: return "Vesi";
            case UtilityTypeEnum.WasteWater: return "Jätevesi";
            case UtilityTypeEnum.StormWater:
            case UtilityTypeEnum.Stream:
            case UtilityTypeEnum.Other:
            case UtilityTypeEnum.SprinklerWater:
            case UtilityTypeEnum.ElectricityTax:
            case UtilityTypeEnum.ElectricityProduction:
                return "TODO: Lisää teksti"; // TODO: Add proper texts.
            default: return null;
        }
    }
}

export class HousingTypeFormat {
    public static toString(housingType: HousingTypeEnum): string {
        switch (housingType) {
            case HousingTypeEnum.UNKNOWN: return "Ei tiedossa";
            case HousingTypeEnum.HOUSE: return "Omakotitalo";
            case HousingTypeEnum.TERRACEDHOUSE: return "Rivitalo";
            case HousingTypeEnum.APARTMENTHOUSE: return "Kerrostalo";
            case HousingTypeEnum.COTTAGE: return "Vapaa-ajan asunto";
            case HousingTypeEnum.DOUBLEHOUSE: return "Paritalo";
            case HousingTypeEnum.OTHER: return "Muu";
            case HousingTypeEnum.INDUSTRIALBUILDING: return "Teollisuuskiinteistö";
            case HousingTypeEnum.COMMERCIALBUILDING: return "Liikekiinteistö";
            case HousingTypeEnum.AGRICULTURALBUILDING: return "Maatalouskiinteistö";
            case HousingTypeEnum.CONCENTRATIONBUILDING: return "Jalostuskiinteistö";
            case HousingTypeEnum.SERVICESECTORBUILDING: return "Palvelualan kiinteistö";
            case HousingTypeEnum.PUBLICSECTORBUILDING: return "Julkisen sektorin kiinteistö";
            case HousingTypeEnum.CONSTRUCTION: return "Rakennustyömaa";
            case HousingTypeEnum.RESIDENTIALPROPERTY: return "Asuinkiinteistö";
            case HousingTypeEnum.COMMUNITYANDUTILITYSERVICE: return "Yhdyskunta- ja hyödykepalvelu";
            case HousingTypeEnum.OUTDOORLIGHTNING: return "Ulkovalaistus";
            case HousingTypeEnum.ELECTRICVECHILECHARGING: return "Sähköajoneuvojen lataus";
            case HousingTypeEnum.TRAFFIC: return "Liikenne";
            case HousingTypeEnum.INDUSTRIALBUILDING2: return "Teollisuuskiinteistö, tyyppi 2";
            case HousingTypeEnum.TERRACEDORDOUBLEHOUSE: return "Rivi- tai paritalo";
            default:
                return null;
        }
    }
}

export class TarificationFormat {
    public static toString(tarification: TarificationIdEnum, locale: string = "fi"): string {
        // TODO: localization
        switch (tarification) {
            case TarificationIdEnum.SINGLETARIF: return "Yksiaika";
            case TarificationIdEnum.DAYNIGHTTARIF: return "Yö-päivä";
            case TarificationIdEnum.SEASONTARIF: return "Kausisähkö";
            case TarificationIdEnum.POWERDAYTARIF: return "Tehoaika";
            case TarificationIdEnum.HEATING: return "Lämpö";
            case TarificationIdEnum.WATER: return "Vesi";
            case TarificationIdEnum.GAS: return "Kaasu";
            case TarificationIdEnum.POWERSEASONTARIF: return "Tehokausi";
            case TarificationIdEnum.DISTRICTCOOLING: return "Kaukokylmä";
            default:
                return null;
        }
    }
}

export class HeatingTypeFormat {
    public static toString(heatingType: HeatingTypeEnum): string {
        switch (heatingType) {
            case HeatingTypeEnum.ELECTRICITY: return "Sähkö";
            case HeatingTypeEnum.NOELECTRICITY: return "";
            case HeatingTypeEnum.GEOTHERMAL: return "Maalämpö";
            case HeatingTypeEnum.DISTRICTHEATING: return "Kaukolämpö";
            case HeatingTypeEnum.OIL: return "Öljy";
            case HeatingTypeEnum.OTHER: return "Muu";
            case HeatingTypeEnum.NOTKNOWN: return "Ei tiedossa";
            case HeatingTypeEnum.GAS: return "Kaasu";
            case HeatingTypeEnum.ELECTRICSTORAGEHEATING: return "Varaava sähkö";
            case HeatingTypeEnum.DIRECTELECTRICHEATING: return "Suora sähkö";
            case HeatingTypeEnum.WOODHEATING: return "Puu";
            case HeatingTypeEnum.HEATPUMP: return "Lämpöpumppu";
            case HeatingTypeEnum.NOHEATING: return "Ei lämmitystä";
            default:
                return null;
        }
    }
}

export class CommonFormatUtils {
    public static formatDuration(contract: IContractViewModel, priceList: IPriceListViewModel, locale: string = "fi") {
        if (!priceList.FixedTerm) {
            if (locale === "fi") {
                return "Toistaiseksi";
            }
            else if (locale === "sv") {
                return "Tillsvidare";
            }
            else if (locale === "en") {
                return "Until further notice";
            }            
        }
            

        let absoluteEndDate = priceList.FixedTermAbsoluteEndDate;
        let duration = priceList.FixedTermDuration;
        let durationUnit = priceList.FixedTermDurationUnit;
        let str = "";

        if (absoluteEndDate != null) {
            //debugger;
            let aed = new Date(absoluteEndDate);
            let csd = new Date(contract.StartDate);
            if (duration != null && duration != 0) {
                if (durationUnit == FixedTermDurationUnit.DAYS) {
                    if (csd > aed) {
                        str += duration + " ";
                        if (locale === "fi") {
                            str += duration === 1 ? "päivä" : "päivää";
                        }
                        else if (locale === "sv") {
                            str += duration === 1 ? "dag" : "dagar";
                        }
                        else if (locale === "en") {
                            str += duration === 1 ? "day" : "days";
                        }
                    }
                    else if (aed > csd.addDays(duration).addDays(-1)) {
                        //str += this.formatDate(csd.addDays(duration).addDays(-1).toDateString());
                        str += duration + " ";
                        if (locale === "fi") {
                            str += duration === 1 ? "päivä" : "päivää";
                        }
                        else if (locale === "sv") {
                            str += duration === 1 ? "dag" : "dagar";
                        }
                        else if (locale === "en") {
                            str += duration === 1 ? "day" : "days";
                        }
                    }
                    else {
                        if (locale === "fi")
                            str += this.formatDate(aed.toDateString()) + " saakka";
                        else if (locale === "sv")
                            str += this.formatDate(aed.toDateString()) + " tills";
                        else if (locale === "en")
                            str += "until " + this.formatDate(aed.toDateString());
                    }
                }
                else if (durationUnit == FixedTermDurationUnit.MONTHS) {
                    if (csd > aed) {
                        str += duration + " ";
                        if (locale === "fi") {
                            str += duration === 1 ? "kuukausi" : "kuukautta";
                        }
                        else if (locale == "sv") {
                            str += duration === 1 ? "månad" : "månader";
                        }
                        else if (locale == "en") {
                            str += duration === 1 ? "month" : "months";
                        }
                    }
                    else if (aed > csd.addMonths(duration)) {
                        //str += this.formatDate(csd.addMonths(duration).addDays(-1).toDateString());
                        str += duration + " ";
                        if (locale === "fi") {
                            str += duration === 1 ? "kuukausi" : "kuukautta";
                        }
                        else if (locale == "sv") {
                            str += duration === 1 ? "månad" : "månader";
                        }
                        else if (locale == "en") {
                            str += duration === 1 ? "month" : "months";
                        }
                    }
                    else {
                        if (locale === "fi")
                            str += this.formatDate(aed.toDateString()) + " saakka";
                        else if (locale === "sv")
                            str += this.formatDate(aed.toDateString()) + " tills";
                        else if (locale === "sv")
                            str += "until " + this.formatDate(aed.toDateString());
                    }
                }
                else if (durationUnit == FixedTermDurationUnit.YEARS) {
                    if (csd > aed) {
                        str += duration + " ";
                        if (locale === "fi") {
                            str += duration === 1 ? "vuosi" : "vuotta";
                        }
                        else if (locale === "sv") {
                            str += duration === 1 ? "år" : "år";
                        }
                        else if (locale === "en") {
                            str += duration === 1 ? "year" : "years";
                        }
                    }
                    else if (aed > csd.addYears(duration).addDays(-1)) {
                        //str += this.formatDate(csd.addYears(duration).addDays(-1).toDateString());
                        str += duration + " ";
                        if (locale === "fi") {
                            str += duration === 1 ? "vuosi" : "vuotta";
                        }
                        else if (locale === "sv") {
                            str += duration === 1 ? "år" : "år";
                        }
                        else if (locale === "en") {
                            str += duration === 1 ? "year" : "years";
                        }
                    }
                    else {
                        if (locale === "fi")
                            str += this.formatDate(aed.toDateString()) + " saakka";
                        else if (locale === "sv")
                            str += this.formatDate(aed.toDateString()) + " tills";
                        else if (locale === "en")
                            str += "until " + this.formatDate(aed.toDateString());
                    }
                 }
             }
            else {
                if (locale === "fi")
                    str += this.formatDate(aed.toDateString()) + " saakka";
                else if (locale === "sv")
                    str += this.formatDate(aed.toDateString()) + " tills";
                else if (locale === "en")
                    str += "until " + this.formatDate(aed.toDateString());
            }
        }
        else {
            switch (durationUnit) {
                case FixedTermDurationUnit.DAYS:
                    str += duration + " ";
                    if (locale === "fi") {
                        str += duration === 1 ? "päivä" : "päivää";
                    }
                    else if (locale === "sv") {
                        str += duration === 1 ? "dag" : "dagar";
                    }
                    else if (locale === "en") {
                        str += duration === 1 ? "day" : "days";
                    }
                    break;
                case FixedTermDurationUnit.MONTHS:
                    str += duration + " ";
                    if (locale === "fi") {
                        str += duration === 1 ? "kuukausi" : "kuukautta";
                    }
                    else if (locale == "sv") {
                        str += duration === 1 ? "månad" : "månader";
                    }
                    else if (locale == "en") {
                        str += duration === 1 ? "month" : "months";
                    }
                    break;
                case FixedTermDurationUnit.YEARS:
                    str += duration + " ";
                    if (locale === "fi") {
                        str += duration === 1 ? "vuosi" : "vuotta";
                    }
                    else if (locale === "sv") {
                        str += duration === 1 ? "år" : "år";
                    }
                    else if (locale === "en") {
                        str += duration === 1 ? "year" : "years";
                    }
                    break;
            }
        }
        return str;
    }

    static formatDate(date: string) {
        return moment(date).format("DD.MM.YYYY");
    }
}

export class GenericTypeFormatTranslator {
    public static toString<T>(toStringFunc: (val: T) => string, input: T, translator: VueI18n) {
        return translator.t(toStringFunc(input));
    }
}

export class ContractReasonFormat {
    public static toString(contractReason: ContractReasonEnum): string {
        switch (contractReason) {
            case ContractReasonEnum.NOTDEFINED: return "Ei määritelty";
            case ContractReasonEnum.SUPPLIERCHANGE:
            case ContractReasonEnum.SUPPLIERCHANGE_DH:
                return "Vaihdan sähkönmyyjää";
            case ContractReasonEnum.MOVEIN:
            case ContractReasonEnum.MOVEIN_DH:
                return "Muutto";
            case ContractReasonEnum.PRODUCTCHANGE:
            case ContractReasonEnum.PRODUCTCHANGE_DH:
                return "Vaihdan nykyisen tai uusin määräaikaisen sopimukseni";
            case ContractReasonEnum.NEWCONTRACT: return "Teen uuden sopimuksen";
            case ContractReasonEnum.NOTKNOWN: return "Ei tiedossa";
            default:
                return null;
        }
    }
}